import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function fetchDomain({ dispatch }, domainId) {
  return http.get(`${MINERVA_API_URL}/domains/${domainId}`)
    .then(res => (
      dispatch('setDomain', res.data)
    ));
}

export function setDomain({ commit }, domain) {
  commit(types.SET_DOMAIN, domain);
}

export function fetchLearningElement({ dispatch }, { domainId, filters }) {
  return http.get(`${MINERVA_API_URL}/cat-domains/${domainId}/learning-elements`, { params: filters })
    .then(res => (
      dispatch('setLearningElement', res.data)
    ));
}

export function setLearningElement({ commit }, learningElement) {
  commit(types.SET_LEARNING_ELEMENT, learningElement);

  return Promise.resolve(learningElement);
}

export function resetLearningElement({ commit }) {
  commit(types.RESET_LEARNING_ELEMENT);
}

export function fetchDomainProficiencyRank({ dispatch }, filters) {
  return http.get(`${MINERVA_API_URL}/users/cl-proficiency-rank`, { params: filters })
    .then(res => (
      dispatch('setDomainProficiencyRank', res.data)
    ));
}

export function setDomainProficiencyRank({ commit }, domainProficiencyRank) {
  commit(types.SET_DOMAIN_PROFICIENCY_RANK, domainProficiencyRank);

  return Promise.resolve(domainProficiencyRank);
}


export function resetDomainProficiencyRank({ commit }) {
  commit(types.RESET_DOMAIN_PROFICIENCY_RANK);
}



// WEBPACK FOOTER //
// ./src/app/cat-proficiency/store/actions.js